import React from "react";
import "./Avatar.scss";
import { AvatarProps } from "./Avatar.types";
import blankSvg from "../Icon/svgs/blank.svg";

const Avatar = ({
    src,
    color,
    height,
    width,
    text,
    alt,
    size,
    shape,
    customClass,
    ...props
}: AvatarProps) => {

  const className = `alteon-avatar alteon-avatar-${size} alteon-avatar-${shape} ${customClass}`;
  return <div className={className} style={{ background: color, width: width, height: height }} {...props}>
      {src ? <img className="ant-avatar-img" src={src} alt={alt} /> : text}
      {!src &&  <img
                src={`${blankSvg}`} />}
    </div>
}

export default Avatar;